import { LiaTableSolid } from "react-icons/lia";

const getDataFieldsHeatmapchart = () => {
  return [
    {
      title: "X-Axis",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Y-Axis",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: Number,
    },
  ];
};

const getCustomizationFieldHeatmapchart = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Legend",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isLegendHeatmapVisible",
      innerComponents: [
        {
          title: "Align",
          type: "SELECT_BOX",
          reduxKey: "legendAlignHeatmap",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
          defaultValue: { label: "Center", value: "center" },
          isParent: true,
        },
        {
          title: "Vertical Align",
          type: "SELECT_BOX",
          reduxKey: "legendVerticalAlignHeatmap",
          options: [
            { label: "Top", value: "top" },

            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Bottom", value: "top" },
          isParent: true,
        },
        {
          title: "Layout",
          type: "SELECT_BOX",
          reduxKey: "legendLayoutHeatmap",
          options: [
            { label: "Horizontal", value: "horizontal" },
            { label: "Vertical", value: "vertical" },
          ],
          defaultValue: { label: "Horizontal", value: "horizontal" },
          isParent: true,
        },
      ],
    },
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLabelVisibleHeatmap",
      innerComponents: [
        {
          title: "Font Color",
          type: "fontColor",

          reduxKey: "labelFontColorHeatmap",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 12,
          minValue: 10,
          maxValue: 40,
          reduxKey: "labelFontSizeHeatmap",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },
    //textbox
    {
      title: "Title",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isTileVisible",
      innerComponents: [
        {
          title: "Title",
          type: "text",
          defaultValue: "title...",
          minValue: 0,
          maxValue: 20,
          reduxKey: "Title",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isTitleBold",
          isParent: true,
        },
        {
          title: "Title Color",
          type: "fontColor",
          reduxKey: "TitleFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Title Size",
          type: "range",
          defaultValue: 25,
          minValue: 8,
          maxValue: 30,
          reduxKey: "TitleSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },

        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },
      ],
    },
  ];
};
const getHeatmapChartDetails = () => {
  return {
    chartType: "echarts",
    imageSrc: "/graph_img/heatmap.png",
    label: "Heatmap",
    value: "heatmapchart",
    icon: <LiaTableSolid className="text-xl text-blue-950" />,
    fileName: "HeatMapChartComp.js",
  };
};
export {
  getDataFieldsHeatmapchart,
  getCustomizationFieldHeatmapchart,
  getHeatmapChartDetails,
};
